import { Form } from 'antd';
import { useIntl } from 'react-intl';
import { DEFAULT_PAGINATION } from 'constants/common';
import { FilterForm } from 'components/form';
import {
  StyledSpace,
  StyledFormItem,
  StyledInputSearch,
} from 'styles/overrides';
import { normalizeSearchData, normalizeSubmitSearchData } from 'utils/common';
import { LocaleSelector } from 'components/selectors';

export default function CategoryFilterSearch({ onSubmit, initialValues }) {
  const intl = useIntl();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    onSubmit(
      normalizeSubmitSearchData({
        ...initialValues,
        ...values,
        page: DEFAULT_PAGINATION.PAGE,
      }),
    );
  };

  const handleValuesChange = (changedValues) => {};

  return (
    <FilterForm
      onFinish={handleSubmit}
      initialValues={normalizeSearchData(initialValues)}
      formInstance={form}
      onValuesChange={handleValuesChange}
    >
      <StyledSpace size={16}>
        <StyledFormItem noStyle shouldUpdate>
          {(form) => (
            <StyledFormItem name="search">
              <StyledInputSearch
                style={{ width: 'auto' }}
                $customType="filter"
                placeholder={intl.formatMessage({
                  id: 'common.placeholder.search',
                })}
                onSearch={form.submit}
              />
            </StyledFormItem>
          )}
        </StyledFormItem>
        <StyledFormItem name="locale_code">
          <LocaleSelector
            placeholder={intl.formatMessage({
              id: 'common.placeholder.locales',
            })}
            $customType="filter"
            isFilter
          />
        </StyledFormItem>
      </StyledSpace>
    </FilterForm>
  );
}
